import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Undo2 } from "lucide-react";

export const undoExport = async (API, id, onDone) => {
  try {
    const { data } = await axios.post(`${API}/crm/export-batches/${id}/undo`);
    toast.dismiss();
    toast.success(`Export ongedaan gemaakt — ${data.restored} lead(s) weer op vóór Mail ${data.step}${data.skipped ? ` (${data.skipped} overgeslagen: inmiddels gewijzigd)` : ""}`);
    onDone?.();
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Ongedaan maken mislukt");
  }
};

export const exportedToast = (API, res, step, onDone) => {
  const n = Number(res.headers["x-exported"] ?? 0);
  const skipped = Number(res.headers["x-skipped"] ?? 0);
  const id = res.headers["x-export-id"];
  toast.success(`Mail ${step}: ${n} lead(s) geëxporteerd én gemarkeerd als verzonden${skipped ? ` — ${skipped} overgeslagen` : ""}`, {
    duration: 20000,
    action: id ? { label: "Ongedaan maken", onClick: () => undoExport(API, id, onDone) } : undefined,
  });
};

export const ExportUndo = ({ API, profile, refreshKey, onDone }) => {
  const [batch, setBatch] = useState(null);

  useEffect(() => {
    axios.get(`${API}/crm/export-batches/last`, { params: { profile } })
      .then(({ data }) => setBatch(data.batch)).catch(() => {});
  }, [API, profile, refreshKey]);

  if (!batch) return null;
  const at = new Date(batch.at).toLocaleString("nl-NL", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  return (
    <div data-testid="crm-last-export" className="flex items-center gap-3 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600">
      <span>Laatste export: <b>Mail {batch.step}</b> · {batch.count} lead(s) · {at}</span>
      <button data-testid="crm-undo-export" onClick={() => undoExport(API, batch.id, () => { setBatch(null); onDone?.(); })}
        className="ml-auto inline-flex items-center gap-1 rounded-full border border-slate-300 px-3 h-7 font-medium hover:bg-white transition-colors">
        <Undo2 className="w-3.5 h-3.5" /> Ongedaan maken
      </button>
    </div>
  );
};
